import React, { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import './Header.css';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-section">
          <img 
            src="/logo-new.png" 
            alt="Aplus Crystal Clean" 
            className="logo-image logo-invert-on-light"
            style={{ height: '70px', width: 'auto', objectFit: 'contain' }}
          />
        </div>
        <nav className="nav-menu">
          <button onClick={() => scrollToSection('hero')} className="nav-link">Home</button>
          <button onClick={() => scrollToSection('about')} className="nav-link">About</button>
          <button onClick={() => scrollToSection('services')} className="nav-link">Services</button>
          <button onClick={() => scrollToSection('booking')} className="nav-link booking-nav-btn">Book Now</button>
        </nav>
      </div>
    </header>
  );
};

export default Header;
